import { ITestFormData } from ".";

export default (form: ITestFormData): Promise<void> => {
  return new Promise(() =>
    setTimeout(
      () => alert(`SENT TO API ${form.chosenColor} - ${form.reason}`),
      1000
    )
  );
};
